import { a as rem, i as _responsive } from "./helpers-bwfx1e-Y.js";
import { t as getTheme_v2 } from "./getTheme_v2-y09KqtEb.js";
/**
* A utility function getting responsive font styles.
* @internal
*/
function responsiveFont(fontKey, props) {
	let { $size, $weight } = props, { font, media } = getTheme_v2(props.theme), { family, sizes, weights } = font[fontKey], fontWeight = $weight && weights[$weight] || weights.regular, defaultSize = sizes[2], base = {
		position: "relative",
		fontFamily: family,
		fontWeight: `${fontWeight}`,
		padding: "1px 0",
		margin: 0,
		"&:before": {
			content: "\"\"",
			display: "block",
			height: 0
		},
		"&:after": {
			content: "\"\"",
			display: "block",
			height: 0
		},
		"& > code, & > span": { display: "block" },
		"&:not([hidden])": { display: "block" }
	};
	return $size ? [base, ..._responsive(media, $size, (sizeIndex) => fontSize(sizes[sizeIndex] || defaultSize))] : (responsiveFont.warned ||= (console.warn("No size specified for responsive font", {
		fontKey,
		$size,
		props,
		base
	}), !0), [base]);
}
function fontSize(size) {
	let { ascenderHeight, descenderHeight, fontSize, iconSize, letterSpacing, lineHeight } = size, negHeight = ascenderHeight + descenderHeight, capHeight = lineHeight - negHeight, iconOffset = (capHeight - iconSize) / 2, customIconSize = Math.floor(fontSize * 1.125 / 2) * 2 + 1, customIconOffset = (capHeight - customIconSize) / 2;
	return {
		fontSize: rem(fontSize),
		lineHeight: `calc(${lineHeight} / ${fontSize})`,
		letterSpacing: rem(letterSpacing),
		transform: `translateY(${rem(descenderHeight)})`,
		"&:before": { marginTop: `calc(${rem(0 - negHeight)} - 1px)` },
		"&:after": { marginBottom: "-1px" },
		"& svg:not([data-sanity-icon])": {
			fontSize: `calc(${customIconSize} / 16 * 1rem)`,
			margin: rem(customIconOffset)
		},
		"& [data-sanity-icon]": {
			fontSize: `calc(${iconSize} / 16 * 1rem)`,
			margin: rem(iconOffset)
		}
	};
}
export { responsiveFont as t };

//# sourceMappingURL=responsiveFont-hN1mZFjm.js.map